import React from 'react';
import { Shield } from 'lucide-react';
import { Heading } from '../layout';
import { useUIColors } from '../../hooks/useTheme';
import { useAdministrationAccess } from '../../contexts/AdministrationAccessContext';

const AdministrationUnlockGate = ({ isDarkMode = false, children }) => {
  const ui = useUIColors();
  const { unlocked } = useAdministrationAccess();

  void isDarkMode;

  if (unlocked) {
    return children;
  }

  return (
    <div style={{ maxWidth: 480, margin: '24px auto 0' }}>
      <Heading level={2} isDarkMode={isDarkMode}>
        Administración
      </Heading>
      <div
        style={{
          marginTop: 14,
          border: `1px solid ${ui.border}`,
          borderRadius: 12,
          background: ui.panel,
          padding: '18px 16px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
          <span
            style={{
              width: 34,
              height: 34,
              borderRadius: 9,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: `color-mix(in srgb, ${ui.interactive} 14%, ${ui.panel})`,
              color: ui.interactive,
            }}
          >
            <Shield size={18} />
          </span>
          <div>
            <div style={{ fontWeight: 750, fontSize: 15, color: ui.text }}>Acceso restringido</div>
            <div style={{ fontSize: 12, color: ui.muted, marginTop: 2 }}>
              Solo usuarios con rol <strong>Administrador</strong> pueden ingresar a este módulo.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdministrationUnlockGate;
